export default (params) => ({
  trigger: {
    name: 'banners.view_banner',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'introduction',
          'primary_location',
          'secondary_location',
          'tertiary_location',
          'top_fallback',
          'bottom_fallback',
          'top_paid',
          'bottom_paid',
        ],
      },
    },
    event: {
      name: 'view_banner',
    },
    nonInt: true,
  },
});
